module.exports = __webpack_public_path__ + "de77a722/img/product-icon-grey.b248963c.svg";